import {
  getClientBlogs,
  getAuthorizedClients,
  saveClientBlogs,
} from "../../api/clientBlogs-communication";

const clientBlogs = {
  namespaced: true,
  state: () => ({
    clientBlogs: null,
    authorizedClients: [],
  }),
  getters: {
    getClientBlogs: (state) => {
      return state.clientBlogs;
    },
    getAuthorizedClients: (state) => {
      return state.authorizedClients;
    },
  },
  actions: {
    fetchClientBlogs({ state, commit }) {
      return new Promise((resolve, reject) => {
        getClientBlogs()
          .then((data) => {
            resolve(data);
            state.clientBlogs = data;
          })
          .catch((err) => {
            console.log("error while getting client blogs" + err);
          });
      });
    },
    fetchAuthorizedClients({ state, commit }) {
      return new Promise((resolve, reject) => {
        getAuthorizedClients()
          .then((data) => {
            resolve(data);
            state.authorizedClients = data;
          })
          .catch((err) => {
            console.log("error while getting authorized clients" + err);
          });
      });
    },
    updateClientBlogs({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        console.log(payload);
        saveClientBlogs(payload)
          .then((resp) => {
            resolve(resp);
            console.log("clientBlogs updated succesfully");
          })
          .catch((err) => {
            console.log("error while updating client blogs");
          });
      });
    },
  },
  mutations: {},
};

export default clientBlogs;
